/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/react-in-jsx-scope */
import DeathByAccident from "../FormMIP/StepTwo/DocumentsForSend/DeathByAccident";
import DeathByDisease from "../FormMIP/StepTwo/DocumentsForSend/DeathByDisease";
import IncapacityByAccident from "../FormMIP/StepTwo/DocumentsForSend/IncapacityByAccident";
import IncapacityByDisease from "../FormMIP/StepTwo/DocumentsForSend/IncapacityByDisease";

export const createPayloadByType = (data, type = "DFI") => {
  const isDFI = type === "DFI";

  const isContactValid =
    data?.NameContact && data?.EmailContact && data?.PhoneNumberContact;

  let payload = {
    natureza: isDFI ? 1 : 2,

    ...(isDFI && {
      vistoria: {
        periodo: data?.SelectDataVisit?.value,
        endereco: data?.Address,
        valorestimadoprejuizo: data?.ValueOfTheLoss,
      },
    }),
  };

  if (data?.CPF) {
    payload = {
      ...payload,
      identificacaosegurado: {
        cpf: data.CPF,
        dataocorrencia: data?.IncidentDate,
        CausaOcorrido: data?.SelectCauseIncident?.id,
        email: data?.Email,
        telefone: data?.PhoneNumber,
        AcompanhamentoProcesso: data?.SelectFeedBack?.value,
        DescricaoSinistro: data?.Message,
      },
    };

    return payload;
  }

  payload = {
    ...payload,
    identificacaocomunicante: {
      NomeComunicante: data?.NameCommunicator,
      GrauParentesco: data?.DegreeOfKinship.value,
      CpfComunicante: data?.CPFCommunicator,
      CPFSegurado: data?.CPFInsured,
      CausaOcorrido: data?.SelectCauseIncident.id,
      dataocorrencia: data?.IncidentDate,
      TelefoneComunicante: data?.PhoneNumber,
      EmailComunicante: data?.Email,
      AcompanhamentoProcesso: data?.SelectFeedBack.value,
      DescricaoSinistro: data?.Message,
      ComunicanteMesmoContato: true,

      ...(isContactValid && {
        dadoscontato: {
          nomecontato: data.NameContact,
          emailcontato: data.EmailContact,
          telefonecontato: data.PhoneNumberContact,
        },
      }),
    },
  };

  return payload;
};

export const ConvertBase64ToBlob = (base64, mimeType = "") => {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
};

const updateDocList = (docs, id, status) =>
  docs.map((doc) => (doc.id === id ? { ...doc, send: status } : doc));

export const updateDocumentSendStatus = (
  causeId,
  id,
  status,
  setDocumentState
) => {
  setDocumentState((prevState) => ({
    ...prevState,
    [causeId]: updateDocList(prevState[causeId], id, status),
  }));
};

export const getDocumentListByCause = (causeId, documents) => {
  const {
    documentListDeathByAccident,
    documentListDeathByDisease,
    documentListIncapacityByAccident,
    documentListIncapacityByDisease,
  } = documents;

  switch (causeId) {
    case 10:
      return documentListDeathByAccident;
    case 9:
      return documentListDeathByDisease;
    case 12:
      return documentListIncapacityByAccident;
    case 11:
      return documentListIncapacityByDisease;
    default:
      return [];
  }
};

export const getMacDocumentId = (key) => {
  switch (key) {
    case "PublicationOfRetirement":
      return 21;
    case "PoliceOccurrence":
      return 4;
    case "DPS":
      return 29;
    case "DriverLicense":
      return 30;
    case "FinancingContract":
      return 5;
    case "RetirementLetter":
      return 20;
    case "MedicalReports":
      return 26;
    case "IMLReport":
      return 18;
    case "DeathCertificate":
      return 12;
    default:
      return 23;
  }
};

export const DocumentCauseForId = (
  causeId,
  documentState,
  setDocumentState
) => {
  if (!documentState) {
    return <></>;
  }

  switch (causeId) {
    case 10:
      return (
        <DeathByAccident
          updateSendStatus={(id, status) =>
            updateDocumentSendStatus(
              "documentListDeathByAccident",
              id,
              status,
              setDocumentState
            )
          }
          documentList={documentState?.documentListDeathByAccident}
        />
      );
    case 9:
      return (
        <DeathByDisease
          updateSendStatus={(id, status) =>
            updateDocumentSendStatus(
              "documentListDeathByDisease",
              id,
              status,
              setDocumentState
            )
          }
          documentList={documentState?.documentListDeathByDisease}
        />
      );
    case 12:
      return (
        <IncapacityByAccident
          updateSendStatus={(id, status) =>
            updateDocumentSendStatus(
              "documentListIncapacityByAccident",
              id,
              status,
              setDocumentState
            )
          }
          documentList={documentState?.documentListIncapacityByAccident}
        />
      );
    case 11:
      return (
        <IncapacityByDisease
          updateSendStatus={(id, status) =>
            updateDocumentSendStatus(
              "documentListIncapacityByDisease",
              id,
              status,
              setDocumentState
            )
          }
          documentList={documentState?.documentListIncapacityByDisease}
        />
      );
    default:
      return <></>;
  }
};

export const ValidateColor = (send) => (send ? "#008000" : "#F36800");
